import { NgModule } from '@angular/core';
import { ZefTranslationsService } from '@zerops/zef/translations';
import { FEATURE_NAME } from './http-routing-item.constant';

const en = {
  statuses: {
    SYNCED: 'Synchronized',
    UNSYNCED: 'Not synchronized',
    BEING_DELETED: 'Being deleted & Not synchronized'
  },
  location: 'Location',
  onOtherServiceStacks: 'on other Services …',
  settingsTooltip: 'Advanced configuration for the location, like redirects, basic auth and rate limiting.',
  sslStatuses: {
    INACTIVE: 'Disabled',
    WAITING_FOR_DNS: 'Waiting for DNS',
    BEING_INSTALLED: 'Installing',
    BEING_RENEWED: 'Renewing',
    ACTIVE: 'Active',
    deployed: 'Active',
    error: 'Error'
  },
  cdnStatuses: {
    DISABLED: 'Disabled',
    BEING_INSTALLED: 'Enabling',
    ACTIVE: 'Active',
    BEING_DISABLED: 'Disabling'
  },
  dnsSectionTitles: {
    PENDING: 'DNS Check Pending',
    CHECKING: 'DNS Checking',
    OK: 'DNS is OK',
    FAILED: 'DNS Check Failed'
  },
  dnsStatuses: {
    PENDING: 'Check Pending',
    CHECKING: 'Checking',
    OK: 'DNS is OK',
    FAILED: 'Traffic from this domain isn\'t reaching the project. Check your DNS records or proxy configuration (e.g. Nginx, Cloudflare) to ensure the domain routes to the project\'s IP addresses.'
  },
  detailLabels: {
    nextCheckAt: 'Next Check',
    lastDnsCheckAt: 'Last Check',
    resolvedNameServers: 'Used Name Servers',
    resolvedIpAddresses: 'Resolved IP Addresses',
    httpChallenges: 'HTTP Challenges',
    dnsChallenges: 'DNS Challenges',
    challengesCalledWithHeader: 'Challenges called with header',
    challengeHost: 'Host',
    challengeUrl: 'URL',
    httpStatusCode: 'HTTP Status',
    httpResponse: 'Response',
    error: 'Error',
    triggerDnsCheck: 'Re-check DNS Now',
    noDnsRecords: 'No IP addresses resolved from DNS.',
    validFrom: 'Valid From',
    validTill: 'Valid Till',
    registeredDomain: 'Registered Domain',
    domainList: 'Covered Domains'
  },
  deploymentStatuses: {
    deployed: 'Deployed',
    notDeployed: 'Not Deployed'
  },
  sslInstallation: {
    title: 'SSL Installation',
    waitingForDns: 'Waiting for DNS/HTTP check to succeed.',
    beingInstalled: 'SSL certificate is being installed. This usually takes a few moments.',
    beingRenewed: 'SSL certificate is being renewed. This process happens automatically before expiration.'
  },
  sslDeployment: {
    title: 'SSL Certificate',
    notDeployedInfo: 'No SSL certificate has been deployed yet. Once the installation completes, the certificate will be deployed automatically.'
  },
  cdnInfo: {
    statusLabel: 'Status:',
    beingInstalled: 'CDN is currently being enabled for this domain.',
    active: 'CDN is active and serving content for this domain.',
    beingDisabled: 'CDN is currently being disabled for this domain.'
  }
};

export type HttpRoutingItemTranslations = typeof en;

@NgModule()
export class HttpRoutingItemTranslationsModule {
  constructor(private _translationsService: ZefTranslationsService) {
    this._translationsService.setTranslations(FEATURE_NAME, { en });
  }
}
